import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">平台特色</h2>
          <p className="mt-2 text-sm text-foreground-500">四大优势 · 品质保障</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-200 text-center group cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors mb-4">
                <i className={`${feature.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}